<template>
  <div>
    <toolbar>
      <template slot="menu">
        <contract-menu />
      </template>
      <template slot="tools">
        <div v-if="contract" class="contract-breadcrumbs">
          <breadcrumb>
            <breadcrumb-item>
              {{ contract.code }}
            </breadcrumb-item>
          </breadcrumb>
        </div>
        <badge class="contract-tasks" :dot="isNewTasks" type="primary">
          <i-button
            @click="toggleModal('feedback')"
            class="dropdown-settings-btn margin-right outline"
            shape="circle"
            style="margin-right:8px;"
          >
            <icon type="md-warning" />
          </i-button>
        </badge>
        <i-button
          @click="toggleModal('history')"
          class="dropdown-settings-btn margin-right outline"
          shape="circle"
        >
          <icon type="md-list" />
        </i-button>
        <i-button
          @click="toggleModal('comments')"
          class="dropdown-settings-btn margin-right outline"
          shape="circle"
        >
          <icon type="ios-chatbubbles" />
        </i-button>
        <dropdown
          v-if="getContractModulePerms('contract_info', 'delete')"
          placement="bottom-end"
          @on-click="settingsClickHandler"
        >
          <i-button class="dropdown-settings-btn" type="primary" shape="circle">
            <icon type="md-settings" />
          </i-button>
          <dropdown-menu slot="list">
            <dropdown-item class="ms-danger" name="delete">
              Удалить проект
            </dropdown-item>
          </dropdown-menu>
        </dropdown>
      </template>
    </toolbar>
    <modal v-model="deleteModal" width="360">
      <p slot="header" style="color: #f60; text-align: center;">
        <icon type="ios-information-circle" />
        <span style="margin-left: 4px;">Удаление проекта</span>
      </p>
      <div style="text-align: center;">
        <p class="ms-text">Вы уверены, что хотите удалить данный проект?</p>
      </div>
      <div slot="footer">
        <i-button
          type="error"
          size="default"
          long
          :loading="deleteLoading"
          @click="deleteProjectHandler"
        >
          Удалить
        </i-button>
      </div>
    </modal>
    <modal
      :footer-hide="true"
      v-model="historyModal"
      width="420"
      :styles="{ top: '80px' }"
    >
      <p slot="header" style="text-align: center;">
        <icon type="md-list" class="ms-help" />
        <span style="margin-left: 4px;" class="ms-help">
          Последние действия
        </span>
      </p>
      <contract-history v-if="historyModal" />
    </modal>

    <modal
      :footer-hide="true"
      v-model="commentsModal"
      width="420"
      :styles="{ top: '80px' }"
    >
      <p slot="header" style="text-align: center;">
        <icon type="ios-chatbubbles" class="ms-help" />
        <span style="margin-left: 4px;" class="ms-help">Комментарии</span>
      </p>
      <contract-comments v-if="commentsModal" />
    </modal>

    <modal
      :footer-hide="true"
      v-model="feedbackModal"
      width="540"
      :styles="{ top: '80px' }"
    >
      <p slot="header" style="text-align: center;">
        <icon type="md-warning" class="ms-help" />
        <span style="margin-left: 4px;" class="ms-help">Исправления</span>
      </p>
      <feedback :contract_id="$route.params.id" />
    </modal>

    <inline-loader v-if="loading" :loading="loading" />
    <router-view v-else />
  </div>
</template>

<script>
import Toolbar from '@/components/toolbar/toolbar'
import ContractMenu from '@/components/contract/contract-menu'
import ContractComments from '@/components/comments/comments'
import ContractHistory from '@/components/history/history'
import Feedback from '@/components/feedback/feedback'
import InlineLoader from '@/components/loaders/inline-loader'

export default {
  components: {
    Toolbar,
    ContractMenu,
    ContractComments,
    ContractHistory,
    Feedback,
    InlineLoader
  },
  data () {
    return {
      loading: false,
      deleteModal: false,
      deleteLoading: false,
      historyModal: false,
      commentsModal: false,
      feedbackModal: false,
      contract: null
    }
  },
  computed: {
    isNewTasks () {
      return this.$store.state.activeTasks.contractTasks
    }
  },
  methods: {
    settingsClickHandler (value) {
      const { id } = this.$route.params

      switch (value) {
        case 'edit':
          this.$router.push(`/app/contracts/edit?id=${id}`)
          break
        case 'delete':
          this.deleteModal = true
          break
      }
    },
    toggleModal (type) {
      this[`${type}Modal`] = !this[`${type}Modal`]
    },
    async deleteProjectHandler () {
      const { id } = this.$route.params

      try {
        this.deleteLoading = true
        await this.$store.dispatch('DELETE_REQUEST', {
          url: `page/project?id=${id}`
        })
        this.deleteLoading = false
        this.deleteModal = false
        this.$router.push('/app/contracts/all')
        this.$Message.success('Проект успешно удален')
      } catch (error) {
        console.log(error)
        this.deleteLoading = false
        this.deleteModal = false
        this.$Message.error('Произошла ошибка при удалении проекта')
      }
    },
    async getContractInfo () {
      try {
        this.loading = true
        const { id } = this.$route.params
        const url = `page/project/${id}`
        this.contract = await this.$store.dispatch('GET_REQUEST', { url })
        this.$store.commit('SET_CURRENT_CONTRACT', this.contract)
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    }
  },
  created () {
    this.getContractInfo()
  }
}
</script>

<style lang="less">
.contract-breadcrumbs {
  margin-right: 24px;

  .ivu-breadcrumb {
    font-size: 11px;

    a {
      color: rgba(255, 255, 255, 0.6);
    }

    & > span:last-child {
      color: rgba(255, 255, 255, 1);
    }

    & > span {
      display: flex;
    }

    &-item-link {
      max-width: 164px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
}

.contract-tasks {
  .ivu-badge-dot {
    top: 4px;
    right: 0;
  }
}
</style>
